import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators, UntypedFormControl } from '@angular/forms';
import { ToastController, LoadingController, AlertController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';
import { COMMA, ENTER, T } from '@angular/cdk/keycodes';
import { SafeUrl } from '@angular/platform-browser';
import _ from 'lodash';
import { CodemirrorComponent } from "@ctrl/ngx-codemirror";
import { MatTabChangeEvent } from '@angular/material/tabs';
// import "codemirror/mode/javascript/javascript"

@Component({
  selector: 'app-api-catalog-details',
  templateUrl: './api-catalog-details.component.html',
  styleUrls: ['./api-catalog-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApiCatalogDetailsComponent implements OnInit {

  @ViewChild(JsonEditorComponent, { static: false }) editor: JsonEditorComponent;
  @ViewChild('image') _image: ElementRef;

  editorOptions: JsonEditorOptions;
  // editorOptions3: JsonEditorOptions;
  dataStructure: any;

  // editorOptions2 = {language: 'text', readOnly: true,
  //   minimap: {
  //     enabled: false
  //   },
  // };
  // monacoEditor;

  @ViewChild("preRequestScriptEditor") _preRequestScriptEditor: CodemirrorComponent;
  preRequestScriptEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    // readOnly: true,
    readOnly: 'nocursor',
    theme: "default",
    mode: { name: "javascript" }
  };
  codeMirrorEditorOptions: any = {
    lineNumbers: true,
    lineWrapping: true,
    theme: "default",
    mode: { name: "text" }
  };
  cursorPos: { line: number; ch: number } = { line: 0, ch: 0 };

  apiCatalogForm: UntypedFormGroup = new UntypedFormGroup({});
  breadcrumbList = [
    {
      label: 'API Catalog',
      embedurl: true,
      url: '/baseapp/api-catalog/view'
    },
    {
      label: 'Details',
      embedurl: false,
      url: '/baseapp/api-catalog/details'
    }
  ];
  categoryList: any;
  brandsList: any;
  sourceNameList: any;
  priceDealsList: any;
  typeList: any;
  methodList: any;
  authenticationTypeOptions: any;
  selectType: number;
  hide1200 = false;
  catalogObj;
  userIp;
  apiSourceName = "bizdata_rest";
  apiResponse;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  selectable = true;
  removable = true;
  token: any;
  tokenexisting: boolean;
  updatedtoken: any;

  type: string = "data_source";

  catalogparamsFlag: boolean = true;
  catalogheadersFlag: boolean = true;

  isEnableImageChanges: boolean = false;
  imagePath: SafeUrl = "../assets/images/upload_image_placeholder.svg";
  selectedFileBlob;
  isImagePresentInServer: boolean = false;
  imageId;
  catalogId;
  workflowList: any;

  selectPaginationType: number = 1;
  paginationTypeOptions: Array<any> = [
    {
      id: 1,
      type: "No Pagination",
      type_value: "no_pagination"
    },
    {
      id: 2,
      type: "Next URL Pagination",
      type_value: "next_url_pagination"
    },
    {
      id: 3,
      type: "Offset Pagination",
      type_value: "offset_pagination"
    },
    {
      id: 4,
      type: "Total Page Count",
      type_value: "total_pages"
    },
    {
      id: 5,
      type: "Pagination with Body",
      type_value: "pagination_with_body"
    },
    {
      id: 6,
      type: "Cursor Pagination",
      type_value: "cursor_pagination"
    },
    {
      id: 7,
      type: "Encoded Next Token",
      type_value: "encoded_next_token_pagination"
    },
    {
      id: 8,
      type: "Custom Pagination",
      type_value: "custom_pagination"
    }
  ]

  user_key_2: string = '';
  user_key_3: string = '';
  user_key_4: string = '';
  user_key_5: string = '';
  user_key_6: string = '';
  user_key_7: string = '';
  user_key_url_6: string = '';
  key_name_to_update_3: string = '';
  key_name_to_update_4: string = '';
  key_name_to_update_5: string = '';
  response_parameters_2: string = '';
  response_parameters_3: string = '';
  response_parameters_4: string = '';
  response_parameters_5: string = '';
  response_parameters_6: string = '';
  response_parameters_7: string = '';
  custom_pagination_script: string = '';
  another_response_parameter_2: string = '';

  constructor(
    private backendService: BackendService,
    public breakpointObserver: BreakpointObserver,
    private fb: UntypedFormBuilder,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public alertController: AlertController,
    private route: ActivatedRoute,
    public helperService: HelperService,
    public storage: Storage
  ) { }

  ngOnInit() {
    this.apiCatalogForm = this.fb.group({
      'api_category': ['', Validators.required],
      'api_brand': ['', Validators.required],
      'api_price': ['', Validators.required],
      'api_type': ['', Validators.required],
      'api_commerce': ['', Validators.required],
      'api_product_name': ['', Validators.required],
      'api_business_object': ['', Validators.required],
      'api_endpoint_method': ['', Validators.required],
      'api_endpoint_url': ['', Validators.required],
      'api_endpoint_params_raw': new UntypedFormArray([]),
      'api_endpoint_headers': new UntypedFormArray([]),
      'api_endpoint_authentication_type': [''],
      'api_endpoint_body_raw': [''],
      'api_response': [''],
      'api_description': ['', Validators.required],
      'workflow_status': ['', Validators.required],
      'dataPrerequestScript': [''],
      'pre_request_script': [''],
      'bridge_source_pagination_type': [''],
      'response_parameters_2': [''],
      'another_response_parameter_2': [''],
      'user_key_2': [''],
      'user_key_3': [''],
      'key_name_to_update_3': [''],
      'response_parameters_3': [''],
      'user_key_4': [''],
      'key_name_to_update_4': [''],
      'response_parameters_4': [''],
      'user_key_5': [''],
      'key_name_to_update_5': [''],
      'response_parameters_5': [''],
      'user_key_6': [''],
      'user_key_url_6': [''],
      'response_parameters_6': [''],
      'user_key_7': [''],
      'response_parameters_7': [''],
      'custom_pagination_script': [''],
      'min_number': [0],
      'max_number': [1000],
    });

    this.editorOptions = new JsonEditorOptions()
    this.editorOptions.mode = 'code'; //set only one mode
    this.editorOptions.mainMenuBar = false;
    this.editorOptions.onEditable=(Node):boolean=>{
      return false;
    }

    // this.editorOptions3 = new JsonEditorOptions()
    // this.editorOptions3.mode = 'code'; //set only one mode
    // this.editorOptions3.mainMenuBar = false;

    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.helperService.loader();
    this.getStorage().then((res) => {
      let payload = { min: "", max: "" }
      let token = res.token;
      let id = this.route.snapshot.params['id'];
      this.backendService.PostAPICall('getAllCategories', payload, token).subscribe(
        data => {
          this.categoryList = data.records;
          this.backendService.GetAPICall('getPrice', token).subscribe(
            data => {
              this.priceDealsList = data;
              this.backendService.GetAPICall('getWorkflowStatus', token).subscribe(
                data => {
                  this.workflowList = data;
                  this.backendService.GetAPICall('getType', token).subscribe(
                    data => {
                      this.typeList = data;
                      this.backendService.GetAPICall('getMethod', token).subscribe(
                        data => {
                          this.methodList = data;
                          this.backendService.GetAPICall('getAuth', token).subscribe(
                            data => {
                              this.authenticationTypeOptions = data;
                              this.getApiCatalogDetails(id);
                            });
                        });
                    });
                });
            });
        });
    })
    this.getUserIp();
    this.apiCatalogForm.disable();
  }

  cursorMoved() {
    this.cursorPos = (this._preRequestScriptEditor.codeMirror as any).getCursor();
  }

  getUserIp() {
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
      })
  }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  editorInit(editor) {
    // Here you can access editor instance
    this.editor = editor;
  }

  validateMinNum(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') && (value <= 100) || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  validateMaxNum(event) {
    let value = event.target.value;
    return ((event.key >= '0' && event.key <= '9') && (value <= 100) || ['ArrowLeft', 'ArrowRight', 'Backspace', ' '].includes(event.key));
  }

  get apiCatalogControls() { return this.apiCatalogForm.controls; }
  get params() { return this.apiCatalogControls.api_endpoint_params_raw as UntypedFormArray; }
  get headers() { return this.apiCatalogControls.api_endpoint_headers as UntypedFormArray; }
  // get businessObjectControls() { return this.apiCatalogControls.api_business_object as FormArray; }

  addValueParams(data: any): UntypedFormGroup {
    //console.log(data.key);
    data = { paramKey: '', paramValue: '', paramDescription: '', ...data }
    return this.fb.group({
      paramKey: new UntypedFormControl({ value: data.key, disabled: true }),
      paramValue: new UntypedFormControl({ value: data.value, disabled: true }),
      paramDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  addValueHeaders(data: any): UntypedFormGroup {
    data = { headerKey: '', headerValue: '', headerDescription: '', ...data }
    return this.fb.group({
      headerKey: new UntypedFormControl({ value: data.key, disabled: true }),
      headerValue: new UntypedFormControl({ value: data.value, disabled: true }),
      headerDescription: new UntypedFormControl({ value: data.description, disabled: true })
    })
  }

  getApiCatalogDetails(id) {
    this.getStorage().then((res) => {
      let payload = {
        ID: (atob(id)),
      }

      this.backendService.PostAPICall('getApiCatalogueSource', payload, res.token).subscribe(
        (data) => {
          let res = data[0];
          this.catalogObj = res;
          let bizdata_rest_json = res?.api_input_structure.input?.bizdata_rest;
          this.helperService.closeLoader();
          //console.log(this.catalogObj);
          this.apiCatalogForm.patchValue(
            {
              firstName: res.first_name,
              lastName: res.last_name,
              email: res.email
            })

          this.imageId = res.api_image;
          this.isImagePresentInServer = res.api_image == null ? false : true;

          if (this.imageId != null) {
            this.getImage(this.imageId);
          }

          let api_category = this.categoryList.filter(function (entry) { return entry.id === res.category.id });
          this.apiCatalogForm.controls['api_category'].setValue(this.catalogObj.category.name);
          this.apiCatalogForm.controls['api_brand'].setValue(this.catalogObj.brand.name);
          let api_price = this.priceDealsList.filter(function (entry) { return entry.id === res.price.id });
          this.apiCatalogForm.controls['api_price'].setValue(this.catalogObj.price.name);
          let workflow_status = this.workflowList.filter(function (entry) { return entry.status_code === res.workflow_status.status_code });
          this.apiCatalogForm.controls['workflow_status'].setValue(this.catalogObj.workflow_status.status);
          let api_type = this.typeList.filter(function (entry) { return entry.id === res.type.id });
          this.apiCatalogForm.controls['api_type'].setValue(this.catalogObj.type.name);
          let api_endpoint_method = this.methodList.filter(function (entry) { return entry.id === bizdata_rest_json?.endpoint_method.id });
          this.apiCatalogForm.controls['api_endpoint_method'].setValue(bizdata_rest_json?.endpoint_method.method);
          let api_endpoint_authentication_type = this.authenticationTypeOptions.filter(function (entry) { return entry.id === bizdata_rest_json?.authentication_type.id });
          this.apiCatalogForm.controls['api_endpoint_authentication_type'].setValue(bizdata_rest_json?.authentication_type.type);

          // let body_raw = bizdata_rest_json.endpoint_body_raw;
          this.apiCatalogForm.controls['api_endpoint_url'].setValue(bizdata_rest_json.endpoint_url);
          let api_url=document.getElementById('api_endpoint_url')
          api_url.style.height=api_url.scrollHeight+'px';
          this.apiCatalogForm.controls['api_endpoint_body_raw'].setValue(bizdata_rest_json.endpoint_body_raw);
          this.apiCatalogForm.controls['pre_request_script'].setValue(bizdata_rest_json.pre_request_script);
          this.apiCatalogForm.controls['api_commerce'].setValue(res.api_commerce);
          this.apiCatalogForm.controls['api_product_name'].setValue(res.api_product_name.product_name);
          this.apiCatalogForm.controls['api_description'].setValue(res.api_description);
          this.apiCatalogForm.controls['api_business_object'].setValue(res.api_business_object[0]);
          // this.apiCatalogForm.controls['api_business_object'].setValue(res.api_business_object);
          // if(res.api_business_object.length > 0){
          //   for (var row of res.api_business_object) {
          //     this.businessObjectControls.push(this.fb.control(row));
          //   }
          // }

          let api_endpoint_params_raw_array = this.apiCatalogForm.get('api_endpoint_params_raw') as UntypedFormArray;
          if (bizdata_rest_json.endpoint_param_raw.length > 0) {
            api_endpoint_params_raw_array.clear();
            for (var row of bizdata_rest_json?.endpoint_param_raw) {
              //console.log(row);
              api_endpoint_params_raw_array.push(this.addValueParams(row));
              //console.log(api_endpoint_params_raw_array);
            }
          } else {
            this.catalogparamsFlag = false;
            // this.addParams(0);
          }

          let api_endpoint_headers_raw_array = this.apiCatalogForm.get('api_endpoint_headers') as UntypedFormArray;
          if (bizdata_rest_json.endpoint_headers.length > 0) {
            api_endpoint_headers_raw_array.clear();
            for (var row of bizdata_rest_json?.endpoint_headers) {
              //console.log(row);
              api_endpoint_headers_raw_array.push(this.addValueHeaders(row));
            }
          } else {
            this.catalogheadersFlag = false;
            // this.addheaders(0);
          }

          let pagination = bizdata_rest_json.pagination
          var id: any;
          for (let item of this.paginationTypeOptions) {
            if (pagination.pagination_style == item.type_value) {
              //console.log(item)
              id = item.id
              this.selectPaginationType = id;
              this.apiCatalogForm.controls['bridge_source_pagination_type'].setValue(item.type);
            }
          }
          if (id == 2) {
            this.user_key_2 = pagination.user_key
            this.response_parameters_2 = pagination.response_parameters
            this.another_response_parameter_2 = pagination.another_response_parameter
            this.apiCatalogForm.patchValue({
              user_key_2: pagination.user_key,
              response_parameters_2: pagination.response_parameters,
              another_response_parameter_2: pagination.another_response_parameter,
            })
          } else if (id == 3) {
            this.user_key_3 = pagination.user_key
            this.key_name_to_update_3 = pagination.key_name_to_update
            this.response_parameters_3 = pagination.response_parameters
            this.apiCatalogForm.patchValue({
              user_key_3: pagination.user_key,
              key_name_to_update_3: pagination.key_name_to_update,
              response_parameters_3: pagination.response_parameters,
            })
          } else if (id == 4) {
            this.user_key_4 = pagination.user_key
            this.key_name_to_update_4 = pagination.key_name_to_update
            this.response_parameters_4 = pagination.response_parameters
            this.apiCatalogForm.patchValue({
              user_key_4: pagination.user_key,
              key_name_to_update_4: pagination.key_name_to_update,
              response_parameters_4: pagination.response_parameters,
            })
          } else if (id == 5) {
            this.user_key_5 = pagination.user_key
            this.key_name_to_update_5 = pagination.key_name_to_update
            this.response_parameters_5 = pagination.response_parameters
            this.apiCatalogForm.patchValue({
              user_key_5: pagination.user_key,
              key_name_to_update_5: pagination.key_name_to_update,
              response_parameters_5: pagination.response_parameters,
            })
          } else if (id == 6) {
            this.user_key_6 = pagination.user_key,
              this.user_key_url_6 = pagination.user_key_url,
              this.response_parameters_6 = pagination.response_parameters,
              this.apiCatalogForm.patchValue({
                user_key_6: pagination.user_key,
                user_key_url_6: pagination.user_key_url,
                response_parameters_6: pagination.response_parameters,
              })
          } else if (id == 7) {
            this.user_key_7 = pagination.user_key,
              this.response_parameters_7 = pagination.response_parameters,
              this.apiCatalogForm.patchValue({
                user_key_7: pagination.user_key,
                response_parameters_7: pagination.response_parameters,
              })
          } else if (id == 8) {
            this.custom_pagination_script = pagination.custom_pagination_script,
              this.apiCatalogForm.patchValue({
                custom_pagination_script: pagination.custom_pagination_script,
              })
          }

          if (pagination.min_num != null && pagination.min_num != undefined) {
            this.apiCatalogForm.patchValue({
              min_number: pagination.min_num
            })
          }
          if (pagination.max_num != null && pagination.max_num != undefined) {
            this.apiCatalogForm.patchValue({
              max_number: pagination.max_num
            })
          }

          if (api_endpoint_authentication_type[0].id == 3) {
            // Bearer Token
            this.apiCatalogForm.addControl('authentication_token', new UntypedFormControl(""));
            this.apiCatalogForm.controls['authentication_token'].setValue(bizdata_rest_json.authentication_token);
            this.apiCatalogForm.controls['authentication_token'].disable();
            this.selectType = 3;
          } else if (api_endpoint_authentication_type[0].id == 4) {
            // Basic Auth
            this.apiCatalogForm.addControl('authentication_username', new UntypedFormControl(""));
            this.apiCatalogForm.addControl('authentication_password', new UntypedFormControl(""));
            this.apiCatalogForm.controls['authentication_username'].setValue(bizdata_rest_json.username);
            this.apiCatalogForm.controls['authentication_username'].disable();
            this.apiCatalogForm.controls['authentication_password'].setValue(bizdata_rest_json.password);
            this.apiCatalogForm.controls['authentication_password'].disable();
            this.selectType = 4;
          } else if (api_endpoint_authentication_type[0].id == 6) {
            // OAuth 2.0
            this.apiCatalogForm.addControl('oauth_refresh_token_endpoint_url', new UntypedFormControl(""));
            this.apiCatalogForm.addControl('oauth_refresh_token_endpoint_method', new UntypedFormControl(""));
            this.apiCatalogForm.addControl('oauth_refresh_token_endpoint_header', new UntypedFormControl(""));
            this.apiCatalogForm.addControl('oauth_refresh_token_endpoint_params', new UntypedFormControl(""));
            this.apiCatalogForm.addControl('oauth_refresh_token_endpoint_body', new UntypedFormControl(""));
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_url'].setValue(bizdata_rest_json.refresh_token_endpoint_url);
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_url'].disable();
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_header'].setValue(bizdata_rest_json.refresh_token_endpoint_header);
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_header'].disable();
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_params'].setValue(bizdata_rest_json.refresh_token_endpoint_params);
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_params'].disable();
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_body'].setValue(JSON.stringify(bizdata_rest_json.refresh_token_endpoint_body));
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_body'].disable();
            let refresh_token_endpoint_method = this.methodList?.filter(function (entry) { return entry.id === bizdata_rest_json.refresh_token_endpoint_method.id });
            //console.log(bizdata_rest_json.refresh_token_endpoint_method);
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_method'].setValue(bizdata_rest_json.refresh_token_endpoint_method.method);
            this.apiCatalogForm.controls['oauth_refresh_token_endpoint_method'].disable();
            this.selectType = 6;
          }

          this.getBrands(api_category[0].id, res);
          this.helperService.closeLoader();
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  getBrands(id, catalogObj) {
    let brandValue = { ID: id };
    this.getStorage().then((res) => {
      this.backendService.PostAPICall('getBrandsByCatId', brandValue, res.token)
        .subscribe(
          data => {
            this.brandsList = data;
            let brand_list = data.filter(function (entry) { return entry.id === catalogObj.brand.id });
            //console.log(brand_list);
          })
    })
  }


  checkAndRemoveBearerTokenControl() {
    const is_authentication_token = this.apiCatalogForm.contains('authentication_token');
    if (is_authentication_token) this.apiCatalogForm.removeControl('authentication_token');
  }

  checkAndRemoveBasicTokenControl() {
    const is_authentication_username = this.apiCatalogForm.contains('authentication_username');
    const is_authentication_password = this.apiCatalogForm.contains('authentication_password');
    if (is_authentication_username) this.apiCatalogForm.removeControl('authentication_username');
    if (is_authentication_password) this.apiCatalogForm.removeControl('authentication_password');
  }

  checkAndRefreshTokenControl() {
    const is_refresh_token_endpoint_url = this.apiCatalogForm.contains('oauth_refresh_token_endpoint_url');
    const is_refresh_token_endpoint_method = this.apiCatalogForm.contains('oauth_refresh_token_endpoint_method');
    const is_refresh_token_endpoint_header = this.apiCatalogForm.contains('oauth_refresh_token_endpoint_header');
    const is_refresh_token_endpoint_params = this.apiCatalogForm.contains('oauth_refresh_token_endpoint_params');
    const is_refresh_token_endpoint_body = this.apiCatalogForm.contains('oauth_refresh_token_endpoint_body');
    if (is_refresh_token_endpoint_url) this.apiCatalogForm.removeControl('oauth_refresh_token_endpoint_url');
    if (is_refresh_token_endpoint_method) this.apiCatalogForm.removeControl('oauth_refresh_token_endpoint_method');
    if (is_refresh_token_endpoint_header) this.apiCatalogForm.removeControl('oauth_refresh_token_endpoint_header');
    if (is_refresh_token_endpoint_params) this.apiCatalogForm.removeControl('oauth_refresh_token_endpoint_params');
    if (is_refresh_token_endpoint_body) this.apiCatalogForm.removeControl('oauth_refresh_token_endpoint_body');
  }

  async presentAlert(header: string, msg: any) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: ['OK']
    });
    return await alert.present();
  }

  getTokenExpirationDate(token): Date {
    const decoded = JSON.parse(atob(token.split('.')[1]));
    if (decoded.exp === undefined) {
      return null;
    }
    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);
    return date;
  }

  async checkInvalidToken() {
    try {
      const token = await this.storage.get('postman-token');
      const date = this.getTokenExpirationDate(token);
      if (date === undefined) {
        return false;
      }
      return !(date.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }

  checktoken() {
    return new Promise((resolve) => {
      this.checkInvalidToken().then(invalid => {
        if (!invalid) {
          resolve(true);
        }
        else {
          resolve(false);
        }
      })
    })
  }


  arrayToObject(arr) {
    return Object.assign({}, ...arr);
  }

  getImage(id) {
    this.getStorage().then((res) => {
      const payload = {
        "img_collection_id": id
      }
      const method = 'post';
      this.backendService.fileUpload('getApiLogoImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.imagePath = 'data:image/jpg;base64,' + data.logo_hash;
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  postmanTabChange(tabChangeEvent: MatTabChangeEvent): void {
    if (tabChangeEvent.tab.textLabel == 'Pre-request Script') {
      this._preRequestScriptEditor.codeMirror.refresh();
    }
  }

}
